import React, { useState } from "react";
import { ToggleIcon, getIcon } from "../../util/icons";

export const FilterLocation = ({
    regions,
    setQueryVar,
    setRegionQueryVar,
    unCheckRegion,
    variables,
    defaultOpen,
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
        // dataLayer.push({'toggleFilter': 'Location'})
    };
    return (
        <div className="location-container">
            <div
                className={`toggle-wrap ${isOpen && "toggle-rotate"}`}
                onClick={toggleOpen}
            >
                <h5>{"Location"}</h5>
                <ToggleIcon />
            </div>
            {isOpen && (
                <div className="dropdown-content">
                    {regions.map((region) => (
                        <LocationParent
                            region={region}
                            setQueryVar={setQueryVar}
                            unCheckRegion={unCheckRegion}
                            setRegionQueryVar={setRegionQueryVar}
                            variables={variables}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

const LocationParent = ({
    region,
    setRegionQueryVar,
    setQueryVar,
    unCheckRegion,
    variables,
}) => {
    const isParentChecked = variables["regionIDs"].find((o) => o === region.id);

    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen(!isOpen);
        dataLayer.push({ event: "Region Toggle", region: region.title });
    };

    let { regionIDs, cityIDs } = variables;

    const regionCityIDs = region.cities.map((c) => c.id);
    const checkedCityIDs = cityIDs.filter((c) => regionCityIDs.includes(c));
    const partiallySelected = regionCityIDs.length !== checkedCityIDs.length;

    const setCityVar = (cityID, checked) => {
        if (checked) {
            if (!regionIDs.includes(region.id)) {
                regionIDs.push(region.id);
            }
            cityIDs.push(cityID);
            setRegionQueryVar(regionIDs, cityIDs);
        } else {
            const regionCityIDs = region.cities.map((c) => c.id);
            const checkedCityIDs = cityIDs.filter((c) =>
                regionCityIDs.includes(c)
            );
            if (checkedCityIDs.length === 1 && checkedCityIDs[0] === cityID) {
                // if last city of the region unchecked
                unCheckRegion(region);
            } else {
                setQueryVar("cityIDs", cityID, true);
            }
        }
    };

    const dataRegion = () => {
        dataLayer.push({ event: "Region Click", region: region.title });
    };

    return (
        <div className="location-parent">
            <div className="location-parent__wrap">
                <div className="location-parent__item">
                    <label>
                        <div className="filter-option-svg" onClick={dataRegion}>
                            {getIcon(true, isParentChecked, partiallySelected)}
                        </div>
                        <input
                            type="checkbox"
                            checked={isParentChecked}
                            value={region.id}
                            onChange={(e) => {
                                const thisID = Number(e.target.value);
                                if (e.target.checked) {
                                    regionIDs.push(thisID);
                                    region.cities.map((c) => {
                                        if (!cityIDs.includes(c.id)) {
                                            cityIDs.push(c.id);
                                        }
                                    });
                                } else {
                                    regionIDs = regionIDs.filter(
                                        (v) => v !== thisID
                                    );

                                    const thisCityIDs = region.cities.map(
                                        (c) => c.id
                                    );
                                    cityIDs = cityIDs.filter(
                                        (n) => !thisCityIDs.includes(n)
                                    );
                                }
                                setRegionQueryVar(regionIDs, cityIDs);
                            }}
                        />
                        <p onClick={dataRegion}>{region.title}</p>
                    </label>
                    <div
                        className={`toggle-parent ${isOpen && "toggle-rotate"}`}
                        onClick={toggleOpen}
                    >
                        <ToggleIcon />
                    </div>
                </div>
                {isOpen && (
                    <div className="location-parent__list">
                        {region.cities.map((city) => (
                            <LocationChild
                                city={city}
                                setCityVar={setCityVar}
                                variables={variables}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const LocationChild = ({ city, setCityVar, variables }) => {
    const isChildChecked = variables["cityIDs"].find((o) => o === city.id);

    const dataCity = () => {
        dataLayer.push({ event: "City Click", city: city.title });
    };

    return (
        <div className="location-child">
            <label>
                <div onClick={dataCity} className="filter-option-svg">
                    {getIcon(true, isChildChecked)}
                </div>
                <input
                    type="checkbox"
                    checked={isChildChecked}
                    value={city.id}
                    onChange={(e) =>
                        setCityVar(Number(e.target.value), e.target.checked)
                    }
                />
                <p onClick={dataCity}>{city.title}</p>
            </label>
        </div>
    );
};
